import { GetVerificationCodeBatchesParams } from "@bvhi/backend-api";
import { Button, Card, CardContent, CardHeader, Grid, TextField } from "@bvhi/ui-base";
import { ClearIcon } from "@bvhi/ui-icons";
import isEqual from "lodash/isEqual";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { defaultVerficationCodesFilter } from "./default-verfication-codes-filter";

interface Props {
  filter: GetVerificationCodeBatchesParams;
  onChange: ({ key, value }: { key: string; value: string | string[] }) => void;
  onReset: () => void;
}

export const VerificationCodesFilterCard = ({ filter, onChange, onReset }: Props) => {
  const { t } = useTranslation(["verification-codes"]);

  const isResetDisabled = useMemo(() => {
    return isEqual(filter, defaultVerficationCodesFilter);
  }, [filter]);

  return (
    <Card>
      <CardHeader
        restrictContentWidth={false}
        title={t("verification-codes:verification.codes.card.filter.title")}
        action={
          <Button color="secondary" disabled={isResetDisabled} endIcon={<ClearIcon />} onClick={onReset} variant="text">
            {t("verification.codes.card.filter.button.reset")}
          </Button>
        }
      />
      <CardContent>
        <Grid container pb={2} spacing={2}>
          <Grid xs={12}>
            <TextField
              fullWidth
              label={t("verification-codes:verification.codes.filter.searchtext.label")}
              placeholder={t("verification-codes:verification.codes.filter.searchtext.placeholder")}
              value={filter.name ?? ""}
              onChange={(e) => {
                onChange({ key: "name", value: e.target.value });
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
